import React from "react";
import {
Box,
Card,
Typography,
Button
} from "@mui/material";

import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Colors } from "../utils/colors";
import { useNavigate } from "react-router-dom";
import BackHeader from "../components/BackHeader";

export default function AccountDeletionNotice(){

const navigate = useNavigate()

return(

<Box
sx={{
minHeight:"100vh",
p:3,
display:"flex",
justifyContent:"center",
alignItems:"center"
}}
>

<Card
sx={{
p:4,
borderRadius:1,
width:"100%",
maxWidth:500,
textAlign:"center"
}}
>

<BackHeader
title="Deletion Request Submitted"
fallbackRoute="/account/authmenu/account/profile-kyc"
titleSx={{color:Colors.accent,fontWeight:700}}
sx={{justifyContent:"center"}}
/>

<WarningAmberIcon
sx={{
fontSize:60,
color:"#ff9800",
mb:2
}}
/>

<Typography
sx={{
mt:2,
color:Colors.muted,
fontSize:15
}}
>
Your account deletion request has been submitted for Admin review.
</Typography>

<Typography
sx={{
mt:1,
color:Colors.muted,
fontSize:15
}}
>
Your profile remains active until an authorized Super Admin reviews and approves the request.
</Typography>

<Typography
sx={{
mt:2,
color:Colors.muted,
fontSize:14
}}
>
If this action was not initiated by you, please contact support immediately.
</Typography>

<Button
fullWidth
variant="contained"
sx={{
mt:4,
backgroundColor:Colors.secondary,
color:"#fff",
fontWeight:700
}}
onClick={()=>navigate("/")}
>
Return to Home
</Button>

</Card>

</Box>

)

}
